import { render, staticRenderFns } from "./PageUrlCreateForm.vue?vue&type=template&id=16b36400"
import script from "./PageUrlCreateForm.vue?vue&type=script&lang=js"
export * from "./PageUrlCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports